import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Topbar from '@/modules/base/components/topbar/topbar'
import { makeStyles } from '@mui/styles'
import debounce from 'lodash/debounce'

import lang from '@/lang'

import config from './../config'
import OAuthConnectView from '@/modules/apps/own/datev/components/oauth-connect-view'
import { toast } from '@/modules/base/components/toast/toastConfig'
import { withAsyncData } from '@/utils/withAsyncData'
import { useNavigate } from 'react-router'

const useStyles = makeStyles(theme => ({
  root: {
    height: `calc(100vh - ${theme.pageContentOffset}px)`,
    display: 'flex',
    flexDirection: 'column',
  },
}))

const TrackingList = props => {
  const navigate = useNavigate()
  const { appId } = props
  const classes = useStyles()

  const [showConnectButton, setShowConnectButton] = useState(false)

  const errorCode = {}

  useEffect(() => {
    if (errorCode?.app) {
      errorCode.app.forEach(error => {
        switch (error.code) {
          case 'uninstalled':
          case 'NOT_FOUND':
            toast.showToast({ type: 'error', message: lang.error.notActivated })
            debounce(() => navigate(`/app/all/show/${appId}`), 2000)()
            break

          case 'verify credentials':
          case 'invalid domain':
            setShowConnectButton(true)
            break
        }
      })
    }
  }, [errorCode])

  useEffect(() => {
  }, [showConnectButton, appId])

  return (
    <div className={classes.root}>
      <Topbar
        customClass={classes.customerDetailsTopbar}
        title='Addison'
        backButtonUrl='/apps'
        variant='white'
      />
      <OAuthConnectView
        authUrl={config.endpoints.authUrl}
        authStatusUrl={config.endpoints.authStatus}
        revokeUrl={config.endpoints.revoke}
      />
    </div>
  )
}

TrackingList.propTypes = {
  appId: PropTypes.string,
}

const fetchData = async({ params }) => {
  const { appId } = params
  return Promise.resolve({ appId })
}

export default withAsyncData(TrackingList, lang.documentExport.forms.exportDatevView.documentTitle, fetchData)
